// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMeetingDenied16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<circle cx={8} cy={8} r={7.5} stroke="#FFB753" />
				<path d="M5.93255 5.05645L8 7.12333L10.0675 5.05645C10.2874 4.83651 10.6315 4.81652 10.8741 4.99646L10.9436 5.05645C11.1855 5.29838 11.1855 5.69062 10.9436 5.93255L8.87667 8L10.9436 10.0675C11.1855 10.3094 11.1855 10.7016 10.9436 10.9436C10.7016 11.1855 10.3094 11.1855 10.0675 10.9436L8 8.87667L5.93255 10.9436C5.71261 11.1635 5.36845 11.1835 5.12593 11.0035L5.05645 10.9436C4.81452 10.7016 4.81452 10.3094 5.05645 10.0675L7.12333 8L5.05645 5.93255C4.81452 5.69062 4.81452 5.29837 5.05645 5.05645C5.29837 4.81452 5.69062 4.81452 5.93255 5.05645Z" />
			</Svg>
		);
	}
);
SvgMeetingDenied16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMeetingDenied16;
